import React from 'react';

const DemoPersonaList = ({ personas, selectedPersonaId, onPersonaSelect }) => {
  return (
    <div className="demo-persona-list">
      <h2 className="demo-persona-title">Persona</h2>
      <div className="demo-persona-items">
        {personas.map(persona => (
          <button
            key={persona.id}
            className={`demo-persona-item ${
              selectedPersonaId === persona.id ? 'demo-persona-item-selected' : ''
            }`}
            onClick={() => onPersonaSelect(persona.id)}
          >
            <div className="demo-persona-name">{persona.name}</div>
            <div className="demo-persona-title-text">({persona.title})</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DemoPersonaList;

